import React from 'react'

import NewReferenceValue from './NewReferenceValue'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'


const NewReferenceValuePage = () => (
  <section>
    <header>
      <PageTitle>New reference value</PageTitle>
    </header>
    <NewReferenceValue showSuccessDialog={true} />
    <br/>
    <BackButton/>
  </section>
)

export default NewReferenceValuePage



// WEBPACK FOOTER //
// ./src/components/ReferenceValues/NewReferenceValuePage.jsx